<form [formGroup]="form" (ngSubmit)="doDirtySubmit()">
  <div class="row">
    <!-- First Name-->
    <div class="col-6">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.first-name" | translate }}</span>
          <lib-input formControlName="firstName" name="firstName"></lib-input>
        </label>
      </lib-form-control>
    </div>

    <!-- Last Name-->
    <div class="col-6">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.last-name" | translate }}</span>
          <lib-input formControlName="lastName" name="lastName"></lib-input>
        </label>
      </lib-form-control>
    </div>
  </div>

  <div class="row">
    <!-- E-mail  -->
    <div class="col-12">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.email" | translate }}</span>
          <lib-input formControlName="email" name="email" [trim]="true"></lib-input>
        </label>
      </lib-form-control>
    </div>

    <!-- Gender  -->
    <div class="col-12">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.gender" | translate }}</span>
          <lib-select [options]="genderOptions" formControlName="gender"></lib-select>
        </label>
      </lib-form-control>
    </div>
  </div>

  <div class="row">
    <!-- Phone -->
    <div class="col-6">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.phone" | translate }}</span>
          <lib-input [mask]="phoneInputMask" formControlName="phone" name="phone" [size]="'m'"></lib-input>
        </label>
      </lib-form-control>
    </div>

    <!-- Data of Birth  -->
    <div class="col-6">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.date-of-birth" | translate }}</span>
          <lib-input
            formControlName="dateOfBirth"
            name="dateOfBirth"
            [mask]="dateInputMask"
            [placeholder]="dateInputPlaceholder"
            [size]="'m'"
          ></lib-input>
        </label>
      </lib-form-control>
    </div>
  </div>

  <!-- CPF -->
  <div class="row">
    <div class="col-6">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.cpf-number" | translate }}</span>
          <lib-input [mask]="cpfInputMask" formControlName="cpf" name="cpf" [size]="'m'"></lib-input>
        </label>
      </lib-form-control>
    </div>

    <!-- External ID -->
    <div class="col-6" *ngIf="hcHasExternalId">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.external-id" | translate }}</span>
          <lib-input formControlName="externalId" name="externalId" [size]="'m'"></lib-input>
        </label>
      </lib-form-control>
    </div>

    <!-- CNS -->
    <div class="col-6" *ngIf="hcHasCns">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.cns" | translate }}</span>
          <lib-input formControlName="cns" name="cns" [size]="'m'"></lib-input>
        </label>
      </lib-form-control>
    </div>
  </div>

  <div class="row">
    <!-- GROUP -->
    <div class="col-12">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.group" | translate }}</span>
        </label>
        <app-patient-invite-control></app-patient-invite-control>
      </lib-form-control>
    </div>
  </div>

  <div class="checkbox-container" *ngIf="hcIncludeAtypicalChildrenGuardian">
    <div class="col-12">
      <lib-form-control>
        <lib-checkbox formControlName="isAtypicalChildGuardian">
          {{ "nouns.is-atypical-children-guardian" | translate }}
        </lib-checkbox>
      </lib-form-control>
    </div>
  </div>

  <button
    libButton
    [isPending]="isPending"
    type="submit"
    [disabled]="!(formValid$ | async)"
    [appearance]="'outline'"
    [size]="'m'"
    class="btnAction"
  >
    {{ patient == null ? ("actions.add-to-list" | translate) : ("patients.edit-button" | translate) }}
  </button>
</form>
